document.querySelectorAll('div.select-bar').forEach(bar => {
    const name = bar.dataset.name;
    const value = bar.dataset.value;

    const input = document.createElement('input');
    input.type = 'text';
    input.name = name;
    input.value = value;
    bar.prepend(input);

    const defaultOption = bar.querySelector(`span[data-value="${value}"]`);
    defaultOption.classList.add('selected');

    bar.querySelectorAll('span').forEach(option => {
        option.addEventListener('click', () => {
            if (option.classList.contains('selected')) return;

            input.value = option.dataset.value;
            input.trigger('change');

            bar.querySelectorAll('span').forEach(option => {
                option.removeClass('selected');
            })
            option.addClass('selected');
        })
    })
})